<template>
  <div class="quarter-log-wrapper" @mouseleave="closeQuarterPopup">
    <button
      class="btn btn-info quarter-btn"
      :class="{ 'no-calls': quarterCalls.length === 0 }"
      @click.stop="openQuarterPopup"
    >
      {{ quarterCalls.length }}
    </button>
    <div
      class="quarter-log"
      v-if="showQuarterStatsPopup"
      v-click-outside="closeQuarterPopup"
    >
      <div
        v-for="(item, index) in quarterCallsStatsArray"
        :key="index"
        class="log-item"
      >
        <div class="log-item-name">{{ item.user.full_name }}</div>
        <div class="log-item-count">{{ item.count }}</div>
      </div>
      <span class="close-quarter-popup" @click.stop="closeQuarterPopup">
        x
      </span>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
  name: "ScheduledCallsQuarterLog",
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      quarterCalls: [],
      showQuarterStatsPopup: false,
      quarterCallsStatsArray: []
    };
  },
  props: {
    dayCalls: {
      type: Array
    },
    quarter: {
      type: Object
    }
  },
  methods: {
    setQuarterStatsArray(call) {
      let tempStatsObj = {
        user: call.user,
        count: 1
      };
      if (this.quarterCallsStatsArray.length > 0) {
        let indexOfCall = this.quarterCallsStatsArray.findIndex(
          callItem => callItem.user.id === call.user.id
        );
        if (indexOfCall === -1) {
          this.quarterCallsStatsArray.push(tempStatsObj);
          this.quarterCallsStatsArray.sort((a, b) => {
            return b.count - a.count;
          });
        } else {
          this.quarterCallsStatsArray[indexOfCall].count++;
          this.quarterCallsStatsArray.sort((a, b) => {
            return b.count - a.count;
          });
        }
      } else {
        this.quarterCallsStatsArray.push(tempStatsObj);
        this.quarterCallsStatsArray.sort((a, b) => {
          return b.count - a.count;
        });
      }
      // if(!this.quarterCallsObject.hasOwnProperty(call.user.id)){
      //   this.quarterCallsObject[call.user.id] = call
      // }
    },
    setQuarterOrder(startTime, time, quarterMinutesStart, quarterMinutesEnd) {
      if (startTime && time.hours() === startTime.hours()) {
        if (
          startTime.minutes() >= quarterMinutesStart &&
          startTime.minutes() < quarterMinutesEnd
        ) {
          return true;
        }
      }
    },
    setQuarterCalls() {
      this.dayCalls.forEach(call => {
        if (
          this.setQuarterOrder(
            call.startTime,
            this.quarter.time,
            this.quarter.quarterStart,
            this.quarter.quarterEnd
          )
        ) {
          this.quarterCalls.push(call);
          this.setQuarterStatsArray(call);
        }
      });
    },
    openQuarterPopup() {
      // event.preventDefault()
      if (this.quarterCalls.length > 0) {
        this.showQuarterStatsPopup = !this.showQuarterStatsPopup;
      }
    },
    closeQuarterPopup() {
      // event.preventDefault()

      this.showQuarterStatsPopup = false;
    }
  },
  mounted() {
    this.setQuarterCalls();
    // console.log()
  }
};
</script>

<style scoped>
.quarter-log-wrapper {
  margin-left: auto;
  position: relative;
}
.quarter-btn {
  height: 23px;
  padding: 0px;
  width: 30px;
}
.quarter-btn:focus {
  outline: none;
}
.quarter-log {
  position: absolute;
  /*background-color: wheat;*/
  height: fit-content;
  width: 185px;
  left: -182px;
  z-index: 2;
  top: -100%;
  padding: 20px;
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
  border-radius: 5px;
  font-size: 13px;
}
.close-quarter-popup {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0px 5px;
}
.close-quarter-popup:hover {
  color: #0a0a0a;
}
.log-item {
  display: flex;
  /*justify-content: space-between;*/
  /*align-items: flex-start;*/
  /*flex: 3;*/
  margin-right: auto;
}
.log-item-count {
  /*flex: 1;*/
  margin-left: auto;
}
.no-calls {
  cursor: default;
  /*pointer-events: none;*/
}
</style>
